import AppTitle from '@theme/components/atom/AppTitle'
import Divider from '@theme/components/molecule/Divider'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  mixins: [HeadingLevel],
  components: {
    AppTitle,
    Divider,
  },
  props: {
    contact: {
      type: Object,
      default() {
        return this.$store.state.globals.contact
      },
    },
  },
}
